<!--
 * @Author: Yran
 * @Date: 2021-07-21 16:30:49
 * @LastEditors: Yran
 * @LastEditTime: 2021-09-01 17:02:57
-->
<template>
  <a-modal v-model:visible="modalVisible" width="11.25rem" :title="delectModalTitle" centered destroy-on-close @ok="onOkClick" @cancel="onCancelClick" class="delect-modal">
    <div class="flexAlignCenter flexJustifyCenter"><ExclamationCircleFilled :style="{ color: '#FF4242', fontSize: '1rem', marginRight: '0.25rem' }" />{{ delectModalContent }}</div>
  </a-modal>
</template>
<script>
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
export default {
  emits: ['onOkClick', 'onCancelClick'],
  components: { ExclamationCircleFilled },
  props: {
    // 删除弹窗显隐
    delectModalVisible: {
      type: Boolean,
      default: false,
    },
    // 删除弹窗标题
    delectModalTitle: {
      type: String,
      default: '删除提示',
    },
    // 删除弹窗标题
    delectModalContent: {
      type: String,
      default: '文件删除后不可恢复，是否确认删除?',
    },
  },
  watch: {
    delectModalVisible(newVal) {
      this.modalVisible = newVal;
    },
  },
  mounted() {
    this.modalVisible = this.delectModalVisible;
  },
  data() {
    return {
      // 删除弹窗显隐
      modalVisible: false,
    };
  },
  methods: {
    /** 确认删除
     * @param {*}
     * @return {*}
     */
    onOkClick() {
      this.$emit('onOkClick');
    },
    /** 取消删除
     * @param {*}
     * @return {*}
     */
    onCancelClick() {
      this.$emit('onCancelClick');
    },
  },
};
</script>
<style lang="less">
.delect-modal {
  .ant-modal-content {
    min-height: 6.75rem;
  }
}
</style>